var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.AllocationTimes},[_vm._v(" "+_vm._s(_vm.row.allocation_count)+" "),_c('span',{class:_vm.$style.m2},[_vm._v("/")]),_c('SpanEdit',{attrs:{"type":"number","inputProps":{
      controlsPosition: 'right',
      min: 0,
      step: 1,
      stepStrictly: true,
      controls: false,
    },"beforeSubmit":_vm.beforeSubmit,"disabled":_vm.disabled},on:{"submit":_vm.onSubmit},model:{value:(_vm.row.times_set),callback:function ($$v) {_vm.$set(_vm.row, "times_set", $$v)},expression:"row.times_set"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }